<main class="team-invite-page">
  <section class="team-invite-card">
    @if (isLoading) {
      <div class="team-invite-loading">
        <mat-spinner diameter="40" aria-label="Loading invitation" />
      </div>
    } @else if (error && !invitation) {
      <mat-icon class="team-invite-icon team-invite-icon--warn" aria-hidden="true">error</mat-icon>
      <h1>Invitation unavailable</h1>
      <p>{{ error }}</p>
    } @else if (invitation) {
      @if (success) {
        <mat-icon class="team-invite-icon team-invite-icon--success" aria-hidden="true">check_circle</mat-icon>
        <h1>{{ invitation.status === 'declined' ? 'Invitation declined' : "You're on the roster" }}</h1>
        <p>{{ success }}</p>
      } @else if (invitation.status !== 'pending') {
        <mat-icon class="team-invite-icon team-invite-icon--warn" aria-hidden="true">info</mat-icon>
        <h1>Invitation {{ invitation.status }}</h1>
        <p>This invitation for {{ invitation.teamName }} is no longer pending.</p>
      } @else if (isShareLinkInvite()) {
        @if (isAuthenticated && invitation.alreadyOnRoster) {
          <mat-icon class="team-invite-icon team-invite-icon--success team-invite-icon--compact" aria-hidden="true">check_circle</mat-icon>
          <p class="team-invite-already-on">You're already on the roster.</p>
          @if (invitation.teamId) {
            <div class="team-invite-actions">
              <a
                mat-flat-button
                color="primary"
                class="team-invite-accept"
                [routerLink]="['/team', invitation.teamId, 'roster']"
              >
                Go to team roster
              </a>
            </div>
          }
        } @else {
          <mat-icon class="team-invite-icon" aria-hidden="true">group_add</mat-icon>
          <p class="team-invite-kicker">Team invite link</p>
          <h1>Join {{ invitation.teamName }}</h1>

          @if (!isAuthenticated) {
            <p>
              Log in or create an account to join this team roster.
              This link expires {{ invitation.expiresAt | date : 'medium' }}.
            </p>
            <div class="team-invite-actions">
              <a
                mat-flat-button
                color="primary"
                [routerLink]="['/auth/login']"
                [queryParams]="{ returnUrl }"
              >
                Log in
              </a>
              <a
                mat-stroked-button
                [routerLink]="['/auth/signup']"
                [queryParams]="{ returnUrl }"
              >
                Create account
              </a>
            </div>
          } @else {
            @if (error) {
              <p class="team-invite-error">{{ error }}</p>
            }
            <div class="team-invite-actions">
              <button
                mat-flat-button
                color="primary"
                type="button"
                class="team-invite-accept"
                (click)="acceptInvitation()"
                [disabled]="isAccepting"
              >
                @if (isAccepting) {
                  <mat-spinner diameter="20" aria-label="Joining team" />
                } @else {
                  Join team
                }
              </button>
            </div>
          }
        }
      } @else {
        <mat-icon class="team-invite-icon" aria-hidden="true">group_add</mat-icon>
        <p class="team-invite-kicker">Team invitation</p>
        <h1>Join {{ invitation.teamName }}</h1>
        <p>
          This invitation was sent to <strong>{{ invitation.email }}</strong>.
          Accept it to be added to the team roster.
        </p>

        @if (!isAuthenticated) {
          <p class="team-invite-hint">
            @if (invitation.hasAccount) {
              Log in with this email, then you can accept the invitation.
            } @else {
              Create an account with this email, then you can accept the invitation.
            }
          </p>
          <div class="team-invite-actions">
            @if (invitation.hasAccount) {
              <a
                mat-flat-button
                color="primary"
                [routerLink]="['/auth/login']"
                [queryParams]="{ returnUrl }"
              >
                Log in
              </a>
            } @else {
              <a
                mat-flat-button
                color="primary"
                [routerLink]="['/auth/signup']"
                [queryParams]="{ returnUrl }"
              >
                Create account
              </a>
            }
            <button
              mat-stroked-button
              type="button"
              class="team-invite-decline"
              (click)="declineInvitation()"
              [disabled]="isDeclining"
            >
              @if (isDeclining) {
                <mat-spinner diameter="18" aria-label="Declining invitation" />
              } @else {
                Decline invite
              }
            </button>
          </div>
        } @else {
          @if (error) {
            <p class="team-invite-error">{{ error }}</p>
          }
          <div class="team-invite-actions">
            <button
              mat-flat-button
              color="primary"
              type="button"
              class="team-invite-accept"
              (click)="acceptInvitation()"
              [disabled]="isAccepting"
            >
              @if (isAccepting) {
                <mat-spinner diameter="20" aria-label="Accepting invitation" />
              } @else {
                Accept invitation
              }
            </button>
            <button
              mat-stroked-button
              type="button"
              class="team-invite-decline"
              (click)="declineInvitation()"
              [disabled]="isDeclining || isAccepting"
            >
              @if (isDeclining) {
                <mat-spinner diameter="18" aria-label="Declining invitation" />
              } @else {
                Decline invite
              }
            </button>
          </div>
        }
      }
    }
  </section>
</main>
